import React, { useState } from 'react';
import { Avatar } from './Avatar';
import { CommentThread } from './CommentThread';
import { ResolveButton } from './ResolveButton';
import { USERS } from './data';
import { Finding, ResolveState } from './types';
interface FindingCardProps {
  f: Finding;
  isBlocker: boolean;
  isFixed: boolean;
  isReviewer: boolean;
  resolveState: ResolveState;
  onResolve: (state: ResolveState) => void;
  expanded: boolean;
  onExpand: (id: string | null) => void;
  currentUser: string;
}
export function FindingCard({
  f,
  isBlocker,
  isFixed,
  isReviewer,
  resolveState,
  onResolve,
  expanded,
  onExpand,
  currentUser
}: FindingCardProps) {
  const [showReg, setShowReg] = useState(false);
  const isDone = isFixed || resolveState === 'resolved';
  const isNA = resolveState === 'na';
  return <div style={{
    marginBottom: 5,
    borderRadius: 8,
    border: `1px solid ${isDone ? '#D1FAE5' : isNA ? '#E2E0DB' : '#E6E4DF'}`,
    background: isDone ? '#F7FDF9' : isNA ? '#FAFAF8' : 'white',
    opacity: isDone || isNA ? 0.5 : 1,
    overflow: 'hidden',
    transition: 'all 0.2s'
  }} data-id="element-86">
      <div onClick={() => onExpand(expanded ? null : f.id)} style={{
      display: 'flex',
      alignItems: 'flex-start',
      gap: 9,
      padding: '10px 12px',
      cursor: 'pointer'
    }} data-id="element-87">
        <div style={{
        width: 18,
        height: 18,
        borderRadius: '50%',
        flexShrink: 0,
        marginTop: 1,
        background: isNA ? '#64748B' : isDone ? '#2D7A6E' : 'white',
        border: isDone || isNA ? 'none' : isBlocker ? '2px solid #B44D4D' : '1.5px solid #D1D5DB',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }} data-id="element-88">
          {isDone && <span style={{
          color: 'white',
          fontSize: 10,
          fontWeight: 800
        }} data-id="element-89">
              ✓
            </span>}
          {isNA && <span style={{
          color: 'white',
          fontSize: 8,
          fontWeight: 800
        }} data-id="element-90">
              —
            </span>}
        </div>

        <div style={{
        flex: 1,
        minWidth: 0
      }} data-id="element-91">
          <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: 6,
          flexWrap: 'wrap'
        }} data-id="element-92">
            <span style={{
            fontSize: 12.5,
            fontWeight: 600,
            color: isDone ? '#2D7A6E' : isNA ? '#94A3B8' : '#1C2530',
            textDecoration: isDone || isNA ? 'line-through' : 'none',
            lineHeight: 1.35
          }} data-id="element-93">
              {f.title}
            </span>
            {isNA && <span style={{
            fontSize: 8,
            fontWeight: 800,
            padding: '1.5px 5px',
            borderRadius: 3,
            background: '#F1F5F9',
            color: '#64748B'
          }} data-id="element-94">
                N/A
              </span>}
          </div>
          {!isDone && !isNA && <div style={{
          fontSize: 12,
          color: '#4A5B6C',
          lineHeight: 1.6,
          marginTop: 3
        }} data-id="element-95">
              {f.desc}
            </div>}
          <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          marginTop: 4
        }} data-id="element-96">
            <span style={{
            fontSize: 10,
            color: '#94A3B8'
          }} data-id="element-97">
              📍 {f.location}
            </span>
            {f.assignee && <span style={{
            display: 'flex',
            alignItems: 'center',
            gap: 3,
            fontSize: 10,
            color: '#94A3B8'
          }} data-id="element-98">
                <Avatar uid={f.assignee} size={14} data-id="element-99" />
                {USERS[f.assignee]?.name.split(' ')[0]}
              </span>}
            {!!f.comments?.length && <span style={{
            fontSize: 10,
            color: '#2563EB',
            fontWeight: 600
          }} data-id="element-100">
                💬 {f.comments.length}
              </span>}
          </div>
        </div>

        {isReviewer && !isFixed && <ResolveButton state={resolveState} onResolve={onResolve} data-id="element-101" />}
        {!isReviewer && (isNA || isDone) && !isFixed && <span style={{
        fontSize: 10,
        fontWeight: 700,
        color: isNA ? '#64748B' : '#2D7A6E',
        background: isNA ? '#F1F5F9' : '#ECFDF5',
        padding: '2px 7px',
        borderRadius: 4,
        flexShrink: 0
      }} data-id="element-102">
            {isNA ? 'N/A' : 'Resolved'}
          </span>}
        {!isDone && !isNA && !isFixed && <span style={{
        fontSize: 9,
        color: '#94A3B8',
        transform: expanded ? 'rotate(180deg)' : 'rotate(0)',
        transition: 'transform 0.15s',
        marginTop: 2
      }} data-id="element-103">
            ▾
          </span>}
      </div>

      {expanded && !isFixed && <div style={{
      padding: '0 12px 12px 39px',
      borderTop: '1px solid #F0EDE8'
    }} data-id="element-104">
          {f.fix && <div style={{
        margin: '8px 0 6px',
        padding: '7px 10px',
        background: '#F0FDF8',
        border: '1px solid #D1FAE5',
        borderRadius: 6
      }} data-id="element-105">
              <div style={{
          fontSize: 9,
          fontWeight: 800,
          color: '#065F46',
          textTransform: 'uppercase',
          letterSpacing: '0.06em',
          marginBottom: 2
        }} data-id="element-106">
                Suggested fix
              </div>
              <div style={{
          fontSize: 12,
          color: '#064E3B',
          lineHeight: 1.6,
          whiteSpace: 'pre-line'
        }} data-id="element-107">
                {f.fix}
              </div>
            </div>}

          {(isReviewer || showReg) && f.reg && <div style={{
        marginTop: 4,
        padding: '4px 8px',
        background: '#F8FAFC',
        borderRadius: 4,
        fontSize: 10,
        color: '#64748B',
        fontFamily: "'JetBrains Mono', monospace"
      }} data-id="element-108">
              {f.reg}
            </div>}
          {!isReviewer && f.reg && !showReg && <button onClick={e => {
        e.stopPropagation();
        setShowReg(true);
      }} style={{
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        fontSize: 10,
        color: '#94A3B8',
        fontFamily: 'inherit',
        padding: '2px 0',
        marginTop: 4
      }} data-id="element-109">
              Show regulation →
            </button>}

          <CommentThread comments={f.comments || []} currentUser={currentUser} data-id="element-110" />
        </div>}
    </div>;
}